<template>
    <section class="booking-order-com f28">
      <div class='contented'>
        <div class="server-img">
          
          <div v-if="fatherItem.state==3&&!fatherItem.showEvaluate&&hasDay>=0" class="order_time">质保剩余{{ hasDay }}天</div>
          <!-- <div v-if="!model.showEvaluate&&hasDay<0" class="order_time">质保已到期</div> -->

          <img  v-if='model.goodsPhoto' :src="formatImgUrl(model.goodsPhoto,300,300,true)" alt=""/>
          <img  v-else-if='model.pic' :src="formatImgUrl(model.pic,300,300,true)" alt=""/>
          <img  v-else :src="formatImgUrl(model.defaultPic,300,300,true)" alt=""/>

          <div class="dis-repair" v-if='makeCheck()'>
            <img src="/images/order/dis-repair.png" alt=""/>
          </div>
        </div>
        <div class="server-info">

          <div v-if='model.brand'>{{model.brand}}</div>

          <div v-if='model.category || model.firstLevelCategory' class='colorG'>{{model.category?model.category:model.firstLevelCategory}}</div>
          <div v-if='model.type == 2 '>{{model.goodsName}}</div>
          <div>{{model.curingServiceName}}</div>
      
        </div>
      </div>
      <div class="server-price">{{model.priceText}}<span v-show='model.quantity'>x{{model.quantity}}</span></div>
    </section>
</template>

<script>
  export default {
    name: 'booking-order-com',
    computed: {
      defaultImg () {
        return this.DEFAULT_IMG
      }
    },
    props: {
      model : {
        type : Object,
        default : ()=>{
          return {}
        }
      },
      fatherItem: {
        type : Object,
        default : ()=>{
          return {}
        }
      },
    },
    data() {
      return {
        hasDay: -1
      }
    },
    created(){
      console.log(this.fatherItem)
      if(this.fatherItem.updateTime) {
        // 创建当前日期对象
        const today = new Date();
        const targetDate = new Date(this.fatherItem.updateTime);
        const timeDiff = Math.abs(targetDate - today);
        const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        console.log(daysDiff); // 输出距离今天过去的天数

        this.hasDay = 90 - daysDiff
      }
    },
    methods : {
      formatImgUrl(url, width, height,m_fill) {
        
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }else{
          url = '/images/base/defult_pic.png'
        }
        return url
      },
      makeCheck(){
        if(this.model.goodsCuringServiceBoList){
          if(this.model.goodsCuringServiceBoList[0]){
            if(this.model.goodsCuringServiceBoList[0].curingServiceName == '无法修复'){
              return true;
            } 
          }
        }
        return false;
      },
    }
  }
</script>

<style scoped lang="scss">
  .colorG{
    color:#666666;
    font-weight:400;
  }
.contented{
  display: flex;
  justify-content: flex-start;
  width: 530px;
}
  .booking-order-com{
    width: 100%;
    display: flex;
    height: 164px;
    justify-content: space-between;
    .server-img{
      flex: none;
      width: 164px;
      height: 164px;
      // overflow: hidden;
      position: relative;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
      .order_time{
        width: 150px;
        height: 44px;
        font-size: 22px;
        line-height: 44px;
        color: white;
        display: block;
        position: absolute;
        background: url('/images/pullNew/order_time.png') no-repeat;
        background-size: cover;
        z-index: 9;
        left: -8px;
      }
      .dis-repair{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,.3);
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 104px;
          height: 104px;
        }
      }
    }
    .server-info{
      margin-left: 30px;
      max-width: 360px;
      flex: auto;
      div{
        line-height: 40px;
        margin-bottom: 20px;
        width: 260px;
        // overflow: hidden;
        font-weight: 500;
        white-space: wrap;
        text-align: left;
        // text-overflow: ellipsis;
      }
    }
    .server-price{
      line-height: 40px;
      font-weight: 500;
      span{
        font-size:20px;
        color:#666666; 
        margin-left:8px;
      }
      // margin-right: 30px;
    }
  }
</style>
